module.exports = __webpack_public_path__ + "img/036-application.5b4bb2ce.svg";